import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { TagsHeaderDesktop as TabsList } from './components/headers/tags-header/desktop';
import { Tabs as Component } from './components/tabs';
import type { ITabsDeps, TTabs } from './components/tabs/models';

export const TabsTagsDesktop = createWidget<ITabsDeps, TTabs>({
    TabsList,
})(Component);
